import * as React from 'react'
import { connect } from 'react-redux'
import { actions } from 'react-redux-form'

import { UI } from 'components/_Assets/svg/Icon/ui'
import { ActionListItem } from 'components/ActionList'
import { AppState } from '../../../../data/state'
import DisplayContent from '../../../shared/content'

interface PeopleProps {
  nrPeople: number
  openModal(): void
}

const People: React.FC<PeopleProps> = props => {
  return (
    <>
      <ActionListItem
        icon={UI.personColored}
        subject={
          <DisplayContent addNode contentKey="with-whom">
            With whom?
          </DisplayContent>
        }
        value={
          <DisplayContent
            addNode
            contentKey="num-people"
            vars={{ people: props.nrPeople.toString() }}
            plural={props.nrPeople > 1}
          >
            {`${props.nrPeople} People`}
          </DisplayContent>
        }
        onClick={props.openModal}
      />
    </>
  )
}

export default connect(
  (state: AppState) => ({
    nrPeople:
      state.funnelOrder.numberOfAdults +
      state.funnelOrder.numberOfChildren +
      state.funnelOrder.numberOfBabies,
  }),
  dispatch => ({
    openModal: () => {
      dispatch(actions.change('ui.viewPersonModal', true))
    },
  }),
)(People)
